import { motion } from "framer-motion";

const INSTAGRAM_URL = "https://www.instagram.com/vison_studios/";

export default function Contact() {
  return (
    <motion.main
      data-testid="contact-page"
      className="pt-14"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center px-6 text-center">
        <h1 className="text-xl font-bold tracking-tight text-neutral-900">Contact</h1>
        <p className="mt-4 text-sm leading-relaxed text-neutral-600">
          The fastest way to reach the studio is a DM on Instagram.
        </p>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-instagram-link"
          className="mt-6 text-sm font-semibold text-neutral-900 underline underline-offset-4 transition-colors hover:text-neutral-500"
        >
          @vison_studios
        </a>
      </div>
    </motion.main>
  );
}
